import { useEffect, useRef, useState } from 'react';

export { useQueryStringUpdate } from './useQueryStringUpdate';
export { default as useInstanceId } from './useInstanceId';
export { default as useMemoCompare } from './useMemoCompare';
export { default as useORMDetails } from './useORMDetails';
export { default as useORMResults } from './useORMResults';

export const usePrevious = value => {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
};

const isClient = typeof window === 'object';
function getSize() {
    return {
        width: isClient ? window.innerWidth : undefined,
        height: isClient ? window.innerHeight : undefined,
    };
}

export const useWindowSize = () => {
    const [windowSize, setWindowSize] = useState(getSize);

    useEffect(() => {
        if (!isClient) {
            return false;
        }

        function handleResize() {
            setWindowSize(getSize());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowSize;
};

export { default as useThunkReducer } from './useThunkReducer';
